/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SparklineResponse = zod
	.array(
		zod
			.object({
				cases: zod.number().describe('Cases on this day'),
				day: zod.iso.date().describe('Calendar date')
			})
			.describe('Daily sparkline data point')
	)
	.describe('List of daily sparkline points');

export type SparklineResponse = zod.input<typeof SparklineResponse>;
export type SparklineResponseOutput = zod.output<typeof SparklineResponse>;
